module.exports = __webpack_public_path__ + "static/unicorn-ba3dc254dd00e0da0a1013166ffebd8e.jpeg";